import { URGENCY_MEETING, URGENCY_SETUP, VOIP } from "plg/meeting/meetingOptions";

// The tracking sheet's values. The UI shows labels; analytics gets stable slugs.

/** Setup and meeting urgency on one scale, so urgency_signup and urgency_request compare. */
const URGENCY_SETUP_SLUGS = ["right_away", "within_month", "within_3_months", "later_this_year", "just_looking"];
const URGENCY_MEETING_SLUGS = ["right_away", "within_month", "within_3_months", "just_looking"];
const VOIP_SLUGS = ["yes", "needs_help", "not_sure"];
/** Sign-up step keys (PLG_SIGNUP_CONFIG) as the sheet names them; other keys are sent as they are. */
const STEP_SLUGS: Record<string, string> = {
  company: "business_details",
  software: "tools",
  epicSetup: "tools_followup",
  cernerSetup: "tools_followup",
};
const INDUSTRY_SLUGS: Record<string, string> = { "Business Administration": "business_admin" };

const byIndex = (labels: string[], slugs: string[], value?: string | null) => {
  const i = value ? labels.indexOf(value) : -1;
  return i >= 0 ? slugs[i] : undefined;
};

/** "When are you looking to hire?" at setup. */
export const urgencySignupSlug = (label?: string | null) => byIndex(URGENCY_SETUP, URGENCY_SETUP_SLUGS, label);
/** The meeting request's urgency, on the same scale as setup so the two compare (the panel prefills one from the other). */
export const urgencyRequestSlug = (label?: string | null) => byIndex(URGENCY_MEETING, URGENCY_MEETING_SLUGS, label);
export const voipSlug = (label?: string | null) => byIndex(VOIP, VOIP_SLUGS, label);
export const stepSlug = (key: string) => STEP_SLUGS[key] || key;

const snake = (v: string) =>
  v
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

/** "Medical" → medical, "Business Administration" → business_admin, "Home Services" → home_services. */
export const industrySlug = (label?: string | null) => (label ? INDUSTRY_SLUGS[label] || snake(label) : undefined);
/** Config sizes use an en dash ("1–10"); the sheet uses "1-10". */
export const sizeBandSlug = (label?: string | null) => (label ? label.replace(/[–—]/g, "-").replace(/\s+/g, "") : undefined);

/** Domain only, never the full address. */
export function emailDomain(email?: string | null): string | undefined {
  const at = email ? email.lastIndexOf("@") : -1;
  return email && at >= 0 ? email.slice(at + 1).trim().toLowerCase() || undefined : undefined;
}
